import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { NavigationHeader } from 'components/NavigationHeader';
import { PageScrollView } from 'components/Page';
import { useEsc } from 'hooks/useEsc';
import { useSelector } from 'hooks/useSelector';
import { GENERICKEY_FIELDREPEATABLELIST } from 'lib/riskbase';
import React from 'react';
import { useDispatch } from 'react-redux';
import { NAVIGATE_MODAL_BACK, SET_GENERIC } from 'store/actions';
import { selectGeneric } from 'store/app/selectors';
import { selectOrganisationFieldGroup } from 'store/organisations/selectors';
import { FieldRepeatableOrderEnum } from 'types/types';

export const FieldInstancesOptionsModal: React.FC<
  ModalScreenProps<ModalScreens.FIELDINSTANCESOPTIONS>
> = ({ route }) => {
  const dispatch = useDispatch();

  const { organisationId, groupId } = route.params;

  const group = useSelector((state) =>
    selectOrganisationFieldGroup(state, organisationId, groupId),
  );

  const genericKeyOrder = GENERICKEY_FIELDREPEATABLELIST({
    groupId,
    where: 'onasset',
    type: 'order',
  });

  const orderValueRaw = useSelector((state) =>
    selectGeneric(state, genericKeyOrder),
  ) as FieldRepeatableOrderEnum | undefined;

  const orderValue =
    (orderValueRaw ? FieldRepeatableOrderEnum[orderValueRaw] : null) ||
    FieldRepeatableOrderEnum.createdAsc;

  const handleSetOrder = (newOrderValue: FieldRepeatableOrderEnum) =>
    dispatch(SET_GENERIC({ key: genericKeyOrder, value: newOrderValue }));

  React.useEffect(() => {
    if (!group) {
      dispatch(NAVIGATE_MODAL_BACK());
    }
  }, [dispatch, group]);

  useEsc(() => dispatch(NAVIGATE_MODAL_BACK()));

  if (!group) {
    return null;
  }

  return (
    <PageScrollView
      header={
        <NavigationHeader
          heading="View Options"
          onPressSaveButton={() => dispatch(NAVIGATE_MODAL_BACK())}
          saveButtonText="Done"
        />
      }
    >
      <Card label={`Order ${group.name} By`}>
        <CardRow
          label="Created"
          value="Oldest First"
          radioValue={orderValue === FieldRepeatableOrderEnum.createdAsc}
          onPress={() => handleSetOrder(FieldRepeatableOrderEnum.createdAsc)}
        />
        <CardRow
          label="Created"
          value="Newest First"
          radioValue={orderValue === FieldRepeatableOrderEnum.createdDesc}
          onPress={() => handleSetOrder(FieldRepeatableOrderEnum.createdDesc)}
        />
        <CardRow
          label="Updated"
          value="Oldest First"
          radioValue={orderValue === FieldRepeatableOrderEnum.updatedAsc}
          onPress={() => handleSetOrder(FieldRepeatableOrderEnum.updatedAsc)}
        />
        <CardRow
          label="Updated"
          value="Newest First"
          radioValue={orderValue === FieldRepeatableOrderEnum.updatedDesc}
          onPress={() => handleSetOrder(FieldRepeatableOrderEnum.updatedDesc)}
        />
      </Card>
    </PageScrollView>
  );
};
